import { useContext } from 'react';

import { DebtConContext } from '@src/app/contexts/DebtCon';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import YourBorrowingView from '@src/ui/views/debtCon/YourBorrowingView';

const YourBorrowing = () => {
    const { loading } = useContext(DebtConContext);

    return (
        <EligibilityLayout loading={loading}>
            <YourBorrowingView />
        </EligibilityLayout>
    );
};

export default YourBorrowing;
